/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Music_Notes_TitleInputs */

const en_insert_music_notes_title = /** @type {(inputs: Insert_Music_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Music Notes`)
};

const fr_insert_music_notes_title = /** @type {(inputs: Insert_Music_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer des notes de musique`)
};

const de_insert_music_notes_title = /** @type {(inputs: Insert_Music_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musiknoten einfügen`)
};

const it_insert_music_notes_title = /** @type {(inputs: Insert_Music_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci note musicali`)
};

const ru_insert_music_notes_title = /** @type {(inputs: Insert_Music_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить ноты`)
};

const es_insert_music_notes_title = /** @type {(inputs: Insert_Music_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar notas musicales`)
};

const zh_cn2_insert_music_notes_title = /** @type {(inputs: Insert_Music_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入音符`)
};

const ja_insert_music_notes_title = /** @type {(inputs: Insert_Music_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音符を挿入する`)
};

const hi_insert_music_notes_title = /** @type {(inputs: Insert_Music_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संगीत नोट्स डालें`)
};

const pt_pt2_insert_music_notes_title = /** @type {(inputs: Insert_Music_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir notas musicais`)
};

/**
* | output |
* | --- |
* | "Insert Music Notes" |
*
* @param {Insert_Music_Notes_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_music_notes_title = /** @type {((inputs?: Insert_Music_Notes_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Music_Notes_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_music_notes_title(inputs)
	if (locale === "de") return de_insert_music_notes_title(inputs)
	if (locale === "it") return it_insert_music_notes_title(inputs)
	if (locale === "ru") return ru_insert_music_notes_title(inputs)
	if (locale === "es") return es_insert_music_notes_title(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_music_notes_title(inputs)
	if (locale === "ja") return ja_insert_music_notes_title(inputs)
	if (locale === "hi") return hi_insert_music_notes_title(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_music_notes_title(inputs)
	return en_insert_music_notes_title(inputs)
});